import * as React from 'react'
import classNames from 'classnames'
import {Location} from 'wix-ui-icons-common'
import {Tags} from '../../../../styled-components/tags'
import s from '../list.scss'
import c from '../../../../classnames.scss'
import {DescriptionProps} from '.'

export const Description = ({name, stageName, tags, t}: DescriptionProps) => (
  <div>
    <h3 className={classNames(s.scheduleTitle, c.scheduleTitleFont, c.scheduleTitleColor)}>{name}</h3>
    {stageName ? (
      <div className={classNames(s.location, c.scheduleLocationFont, c.scheduleLocationColor)}>
        <Location aria-label={t('schedule_location_aria')} /> {stageName}
      </div>
    ) : null}
    {tags ? (
      <Tags
        className={s.tags}
        items={tags?.map(tag => ({
          title: tag,
          value: tag,
        }))}
      />
    ) : null}
  </div>
)
